import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { ApiRoutesProductSets } from "../../constants";
import { ProductSetsReorderBody } from "./productSetsReorder.types";

export const requestProductSetsReorder = async ({
  id,
  newOrder
}: ProductSetsReorderBody): Promise<void> => {
  return await instance.patch(
    buildUrl(
      ApiRoutesProductSets.ProductSets,
      id,
      ApiRoutesProductSets.Reorder
    ),
    { newOrder }
  );
};
